import { useEffect, useState } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import styles from './App.module.css'
import { Notifications } from './components/Notifications/Notifications'
import { useAuthGuard } from './hooks/useAuthGuard'
import { AuthRoutes } from './routes/AuthRoutes'
import { MainRoutes } from './routes/MainRoutes'
import { RegistrationRoutes } from './routes/RegistrationRoutes'
import useAccessStore from './store/accessStore'

const AppRoutes = () => {
  useAuthGuard()

  return (
    <Routes>
      <Route index element={<Navigate to="login" replace />} />
      {AuthRoutes()}
      {RegistrationRoutes()}
      {MainRoutes()}
      <Route path="*" element={<Navigate to="login" replace />} />
    </Routes>
  )
}

function App() {
  const [isInitializing, setIsInitializing] = useState(true)
  const { initialize, initialized } = useAccessStore()

  useEffect(() => {
    const initializeApp = async () => {
      try {
        await initialize()
        setIsInitializing(false)
      } catch (error) {
        console.error('Failed to initialize app:', error)
        setIsInitializing(false)
      }
    }

    initializeApp()
  }, [initialize])

  if (!initialized || isInitializing) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.loadingSpinner} />
        <p className={styles.loadingText}>Loading...</p>
      </div>
    )
  }

  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <AppRoutes />
      <Notifications />
    </BrowserRouter>
  )
}

export default App
